import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import QRTokenService from '../services/QRTokenService';
import { toast } from 'react-toastify';

const ScanHandlerPage = () => {
    const { token } = useParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const verifyAndRoute = async () => {
            try {
                const status = await QRTokenService.verifyToken(token);
                
                if (status.assigned) {
                    if (status.assetId) {
                        // Redirect to PUBLIC view using the TOKEN instead of sequential ID
                        navigate(`/public/assets/${token}`);
                    } else if (status.locationId) {
                        // Redirect to PUBLIC view using the TOKEN instead of sequential ID
                        navigate(`/public/locations/${token}`);
                    }
                } else {
                    // Unassigned! Mark as scanned and redirect to create asset with token parameter
                    await QRTokenService.markAsScanned(token).catch(e => console.error(e));
                    toast.info("Unassigned QR code detected. Create a new asset to link it.");
                    navigate(`/admin?page=scan_registration&qrToken=${token}`);
                }
            } catch (error) {
                toast.error("Invalid or expired QR token.");
                navigate('/admin');
            } finally {
                setLoading(false);
            }
        };

        if (token) {
            verifyAndRoute();
        }
    }, [token, navigate]);

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', flexDirection: 'column' }}>
            {loading ? (
                <>
                    <div className="spinner"></div> {/* Use existing spinner class if available */}
                    <p style={{ marginTop: '20px', color: '#64748b' }}>Processing QR scan: <strong>{token}</strong>...</p>
                </>
            ) : (
                <p>Redirecting...</p>
            )}
        </div>
    );
};

export default ScanHandlerPage;
